/* global document, FileReader */
// Pick any file and return it as a data URI. Web only for now — the native
// build has no document picker installed, so it resolves null there.
export async function pickFile() {
  if (typeof document === 'undefined') return null;
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    let done = false;
    const finish = (v) => { if (done) return; done = true; input.remove(); resolve(v); };
    input.addEventListener('change', () => {
      const f = input.files && input.files[0];
      if (!f) return finish(null);
      const reader = new FileReader();
      reader.onload = () => finish({ dataUrl: String(reader.result), name: f.name || 'file', size: f.size || 0, type: f.type || 'application/octet-stream' });
      reader.onerror = () => finish(null);
      reader.readAsDataURL(f);
    });
    // best-effort cancel detection
    window.addEventListener('focus', () => setTimeout(() => { if (!input.files || !input.files.length) finish(null); }, 800), { once: true });
    input.click();
  });
}
